import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";

const PromoCustomerStatusFilterModal = ({
  statusFilterModalVisible,
  setStatusFilterModalVisible,
  sendDataToOrdersPageFromFilter,  
  OrderStatus,
  status,
  text,
}) => {
  
  const [selectedStatus, setSelectedStatus] = useState([]);

  useEffect(() => {
    // Update localSelectedStatus when selectedStatus changes
    setSelectedStatus(OrderStatus);
  }, [OrderStatus]);

  const handleStatusToggle = (status) => {
    const updatedStatus = [...selectedStatus];

    if (updatedStatus.includes(status)) {
      // Remove status if already selected
      updatedStatus.splice(updatedStatus.indexOf(status), 1);
    } else {
      // Add status if not selected
      updatedStatus.push(status);
    }

    setSelectedStatus(updatedStatus);
  };
  const handleConfirmPickup = () => {
    // Close the modal
    setStatusFilterModalVisible(false);
    sendDataToOrdersPageFromFilter(
      selectedStatus.length > 0 ? selectedStatus : "ALL"
    );
  };

  const handleModalClose = () => {
    setStatusFilterModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={statusFilterModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!statusFilterModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                Select Status
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                {OrderStatus?.map((statusItem) => (
                  <div
                    key={statusItem}
                    className="flex flex-1 justify-content-between my-1"
                  >
                    <p className="text-xl font-medium">
                      {statusItem.replace(/_/g, " ")}
                    </p>
                    <div>
                      <Checkbox
                        checked={selectedStatus.includes(statusItem)}
                        size="20" // Increased size
                        color={
                          selectedStatus.includes(statusItem)
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() => handleStatusToggle(statusItem)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <Button
              onClick={handleConfirmPickup}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Filter
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default PromoCustomerStatusFilterModal;
